import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/o_nas',
      name: 'o_nas',
      // route level code-splitting
      // this generates a separate chunk (o_nas.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "o_nas" */ './views/O_nas.vue'),
    },
    {
      path: '/oferty',
      name: 'oferty',
      component: () => import('./views/Oferty.vue'),
    },
    {
      path: '/oferty/:id',
      name: 'trip',
      component: () => import('./views/Trip.vue'),
    },
    {
      path: '/kontakt',
      name: 'kontakt',
      component: () => import('./views/Kontakt.vue'),
    },
    {
      path: '/rezerwacje',
      name: 'reservations',
      component: () => import('./views/Reservations.vue'),
    },
    {
      path: '/subskrypcje',
      name: 'subscriptions',
      component: () => import('./views/Subscriptions.vue'),
    },
    {
      path: '/klienci',
      name: 'customers',
      component: () => import('./views/Customers.vue'),
    },
    {
      path: '/wiadomosci',
      name: 'contacts',
      component: () => import('./views/Contacts.vue'),
    },
    {
      path: '/login/',
      name: 'login',
      component: () => import('./views/Login.vue'),
    },
    {
      path: '*',
      name: '404',
      component: () => import('./views/NotFound.vue'),
    },
  ],
})

router.afterEach((to, from) => {
  window.scroll({ top: 0 })
})

export default router
